module.exports = __webpack_public_path__ + "collegia.png?3ceb834ef374706aafdfe3bb0dfcd1a9";


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/img/collegia.png
// module id = 456
// module chunks = 0